<template>
    <v-dialog v-model="modal" width="800px" max-width="100%">
        <v-card v-if="offer" width="800px" max-width="100%" class="pa-md-3">
            <v-card-title>
                <span class="text-h6">
                    {{ `${offer.name}` }}
                </span>
                <v-icon class="v-card-close ma-4" @click="modal = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="text-black">
                <v-tabs v-model="tab" class="mb-4">
                    <v-tab>
                        {{ $t('description') }}
                    </v-tab>
                </v-tabs>
                <v-window v-model="tab">
                    <v-window-item>
                        <v-row>
                            <template v-if="offer.serviceDescription || info.productDescription">
                                <v-col v-if="offer.serviceDescription" cols="12">
                                    <div v-html="offer.serviceDescription" />
                                </v-col>
                                <v-col v-if="info.productDescription" cols="12">
                                    <div v-html="info.productDescription" />
                                </v-col>
                            </template>
                            <v-col v-else cols="12" class="d-flex align-center flex-column justify-center">
                                <div class="text-center text-caption text--secondary">
                                    {{ $t('no_data') }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_VISA_OFFER_INFO_MODAL} from '@/utils/event-bus'

    //TODO Need refactoring with other products
    @Component
    export class VisaOfferInfoModal extends Vue {
        offer = null
        info = null
        modal = false
        tab = null

        mounted() {
            EventBus.$on(SHOW_VISA_OFFER_INFO_MODAL, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_VISA_OFFER_INFO_MODAL, this.showModal)
        }

        showModal({offer, info}) {
            this.offer = offer
            this.info = info
            this.modal = true
        }
    }

    export default VisaOfferInfoModal
</script>
